import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@fortem-monorepo/js-utilities';
function Skeleton({ className, ...props }) {
    return (_jsx("div", { "data-slot": "skeleton", className: cn('bg-neutral-200/70 animate-pulse rounded-md', className), ...props }));
}
export { Skeleton };
